import { render, staticRenderFns } from "./PeopleThumb.vue?vue&type=template&id=5d915f1a&scoped=true&"
import script from "./PeopleThumb.vue?vue&type=script&lang=js&"
export * from "./PeopleThumb.vue?vue&type=script&lang=js&"
import style0 from "./PeopleThumb.vue?vue&type=style&index=0&id=5d915f1a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d915f1a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonPlay: require('/opt/build/repo/components/ButtonComponents/ButtonPlay.vue').default})
